import { Expose } from "class-transformer";

export class CreateProjectPhaseDto {
  @Expose()
  code: string;

  @Expose()
  name: string;
}
